import type { ChartOptions, ChartData, Point, TooltipItem } from 'chart.js';
import type * as ChartJs from 'chart.js';
import React from 'react';
import { Doughnut } from 'react-chartjs-2';

import { useIsMobile } from '@hooks/useIsMobile';

import '../register';

export type DoughnutChartDataset = ChartData<'doughnut', number[], unknown>;
export type DoughnutChartPlugin = ChartJs.Plugin<'doughnut', Point[]>;

export interface DoughnutChartOptions {
  /** Doughnut chart slice's text (shown with the slice's colour) */
  formatLabel?: (label: TooltipItem<'doughnut'>) => string;
  /** Doughnut chart slice's label */
  formatTitle?: (title: TooltipItem<'doughnut'>[]) => string;
  /** Chart's ratio of width to height */
  aspectRatio?: number;
}

interface DoughnutChartProps {
  chartData: DoughnutChartDataset;
  plugins?: DoughnutChartPlugin[];
  options?: DoughnutChartOptions;
}

export default function DoughnutChart({
  chartData,
  options,
  plugins,
}: DoughnutChartProps) {
  const isMobile = useIsMobile();
  const py = isMobile ? 0 : 75;

  const defaultData: DoughnutChartDataset = {
    ...chartData,
  };

  const defaultOptions: ChartOptions<'doughnut'> = {
    maintainAspectRatio: true,
    aspectRatio: options?.aspectRatio ?? 1,
    layout: {
      padding: {
        top: py,
        bottom: py,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          ...(options?.formatLabel && {
            label: (tooltipItem) => {
              return options.formatLabel?.(tooltipItem);
            },
          }),
          ...(options?.formatTitle && {
            title: (items) => {
              return options.formatTitle?.(items);
            },
          }),
        },
      },
    },
  };

  return (
    <Doughnut data={defaultData} options={defaultOptions} plugins={plugins} />
  );
}
